"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var react_transition_group_1 = require("react-transition-group");
var Portal_1 = require("../base/Portal");
var notification_1 = require("../notification");
var StackNotification = /** @class */ (function (_super) {
    tslib_1.__extends(StackNotification, _super);
    function StackNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function (timeout) {
            var _a = _this.props, notification = _a.notification, onClose = _a.onClose;
            onClose(notification, timeout);
            notification.onClose && notification.onClose(timeout);
        };
        return _this;
    }
    StackNotification.prototype.render = function () {
        var _a = this.props, notification = _a.notification, className = _a.className, index = _a.index;
        return (React.createElement(notification_1.Notification, { error: notification.error, warning: notification.warning, success: notification.success, timeout: notification.timeout, title: notification.title, text: notification.text, iconName: notification.iconName, iconSize: notification.iconSize, onClose: this.onClose, className: className, style: { bottom: utils_1.toREMString(index * (8.4 + 2)) } }));
    };
    return StackNotification;
}(React.Component));
var stackStyleFactory = function (position, horizontalGap, verticalGap) {
    var _a;
    return (_a = {
            paddingBottom: utils_1.toREMString(verticalGap)
        },
        _a["padding" + utils_1.capitalize(position)] = utils_1.toREMString(horizontalGap),
        _a);
};
var transitionClassesFactory = function (theme) {
    return {
        enter: theme.notificationEnter,
        enterActive: theme.notificationEnterActive,
        exit: theme.notificationLeave,
        exitActive: theme.notificationLeaveActive
    };
};
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, onClose = _a.onClose, notifications = _a.notifications, _b = _a.position, position = _b === void 0 ? "right" : _b, _c = _a.horizontalGap, horizontalGap = _c === void 0 ? 2 : _c, _d = _a.verticalGap, verticalGap = _d === void 0 ? 2 : _d;
    return (React.createElement(Portal_1.default, null,
        React.createElement("div", { className: classnames_1.default(theme.stack, className, theme[position]), style: stackStyleFactory(position, horizontalGap, verticalGap) },
            React.createElement("div", { className: theme.inner },
                React.createElement(react_transition_group_1.TransitionGroup, { component: null }, notifications.map(function (notification, index) { return (React.createElement(react_transition_group_1.CSSTransition, { unmountOnExit: true, classNames: transitionClassesFactory(theme), timeout: 300, key: notification.id },
                    React.createElement(StackNotification, { index: (notifications.length - 1) - index, notification: notification, onClose: onClose, className: classnames_1.default(theme.notification, notification.className) }))); }))))));
});
